import { Controller } from "@hotwired/stimulus"

// Mirrors the in-app unread count to the installed-PWA app-icon badge while the
// app is OPEN (Web Push covers the away case). Re-applied whenever the live nav
// badge is replaced via Turbo Stream (a fresh element connects). Feature-detected
// and fully guarded — unsupported browsers simply skip it.
export default class extends Controller {
  static values = { count: Number }

  connect() {
    this.apply(this.countValue)
  }

  apply(n) {
    try {
      if (!("setAppBadge" in navigator)) return
      if (n > 0) navigator.setAppBadge(n)
      else navigator.clearAppBadge()
    } catch (_) {
      /* Badging API unavailable — ignore. */
    }
  }
}
